// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__27uUG","modalFooterButton":"ModalNotes_modalFooterButton__3_uIW"};